export default theme => ({
  container: {
    marginTop: theme.spacing(4),
    padding: '0 10%',
    [theme.breakpoints.down('lg')]: {
      padding: '0 5%'
    }
  },
  grow: {
    flexGrow: 1
  },
  paper: {
    width: '10rem',
    height: '8rem'
  },
  detailPaper: {
    height: '20rem'
  },
  borderBottom: {
    borderBottom: '1px solid ' + theme.palette.divider
  },
  capabilityName: {
    width: '60%',
    color: theme.palette.secondary.main
  },
  headerRow: {
    backgroundColor: '#f3f3f3'
  },
  row: {
    backgroundColor: '#f3f3f3',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.overrides.MuiSelected.root['&:hover'].backgroundColor + '!important',
      '& th': {
        color: theme.palette.text.primary
      }
    }
  },
  oddRow: {
    backgroundColor: theme.palette.primary.main
  },
  COMPLETED: {
    color: theme.palette.secondary.main
  },
  tableText: {
    fontSize: '0.7rem'
  },
  tableHeader: {
    fontSize: '0.7rem',
    color: theme.palette.text.secondary,
    fontWeight: 'bold'
  },
  table: {
    border: '1px solid ' + theme.palette.divider,
    overflow: 'hidden',
    '& tbody > tr:last-child > td': {
      border: 'none'
    }
  }
});
